import { render } from "./PerformanceMarketingPaymentWalletOption.vue?vue&type=template&id=38b719b3"
import script from "./PerformanceMarketingPaymentWalletOption.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingPaymentWalletOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__